export const formGroupLocator = {
    kodeLocation: {value: "", mandatory: true},
    kodeCabang: {value: {}, mandatory: true},
    nameLocation: {value: "", mandatory: true},
    status: {value: "ACTIVE"},
};